import React from 'react';

import { DatePicker } from 'material-ui-pickers';

import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import LinearProgress from '@material-ui/core/LinearProgress';
import TextField from '@material-ui/core/TextField';

import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';
import ViewDayIcon from '@material-ui/icons/ViewDay';

import DataTableToolbar from '../_Shared/DataTables/DataToolbar';
import DataTable from '../_Shared/DataTables/DataTable';
import CreateModal from '../_Shared/CreateModal';
import AppContent from '../_Shared/Layout/AppContent';
import Select from '../_Shared/SearchableDropdown'

const uuidv4 = require('uuid/v4');
const moment = require('moment');
const defaultCampaign = {
    name: '',
    startDate: moment().add(1, 'day'),
    endDate: moment().add(7, 'day')
}

class CampaignList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showCreateModal: false,
            campaign: defaultCampaign,
            anchorEl: null
        }

        this.handleInputChange = this.handleInputChange.bind(this);
    }

    toggleRowMenu = currentTarget => {
        this.setState((prevState) => {
            return { anchorEl: prevState.anchorEl === currentTarget ? null : currentTarget }
        })
    }

    closeToggleRowMenu = () => {
        this.setState({ anchorEl: null });
    }

    toggleCreateModal = e => {
        const { showCreateModal } = this.state;
        this.setState({ showCreateModal: !showCreateModal, campaign: defaultCampaign });
    }

    handleInputChange = (name, value) => {
        this.setState((prevState, state) => {
            return { campaign: Object.assign({}, prevState.campaign, { [name]: value, }) }
        });
    }

    selectElement = campaign => {
        this.setState({ campaign });
    }

    createCampaign = e => {
        const { onCampaignAdded } = this.props;
        const { campaign } = this.state;
        onCampaignAdded(Object.assign({}, campaign, { id: uuidv4().replace(/-/g, ''), version: 1, layers: [] }));
        this.setState({ showCreateModal: false });
    }

    deleteCampaign = event => {
        const { onCampaignRemoved } = this.props;
        const { campaign } = this.state;
        onCampaignRemoved(campaign);
        this.setState({ campaign: defaultCampaign, anchorEl: null });
    }

    loadCampaigns = () => {
        const { onLoadCampaigns, campaigns, processing } = this.props;
        if (!processing) { onLoadCampaigns(campaigns); }
    }

    advertiser = () => {
        const { advertisers } = this.props;
        const { campaign } = this.state;

        if (campaign.advertiserId) {
            let advertiser = advertisers.find(x => x.id === campaign.advertiserId);
            if (advertiser) { return advertiser; }
        }

        return { brands: [] };
    }

    render() {
        const { campaigns, advertisers, onEdit, loading, advertisersLoading, processing } = this.props;
        const { showCreateModal, campaign, anchorEl } = this.state;
        const selectedAdvertiser = this.advertiser();
        return (<AppContent>
            {
                (loading || processing) && <LinearProgress variant="query" />
            }
            <DataTableToolbar title="Campaigns" numSelected={0} >
                <Tooltip title="Add New">
                    <IconButton onClick={this.toggleCreateModal} color="secondary"><AddCircleIcon /></IconButton>
                </Tooltip>
            </DataTableToolbar>
            {
                campaigns && campaigns.items &&
                <DataTable columns={[ { label: 'Name', field: 'name' }]} anchorEl={anchorEl} toggleRowMenu={this.toggleRowMenu} onElementSelect={this.selectElement}
                    onCloseToggleRowMenu={this.closeToggleRowMenu} rows={
                        campaigns.items
                    } nextToken={campaigns.nextToken} onLoad={this.loadCampaigns}
                    defaultAction={campaign => onEdit(`/media/campaigns/${campaign.id}/v${campaign.version}/manage/media-plan`, campaign)}>
                    <MenuItem onClick={() => onEdit(`/media/campaigns/${campaign.id}/v${campaign.version}/manage/settings`, campaign)}>
                        <ListItemIcon><EditIcon /></ListItemIcon>
                        <ListItemText inset primary="Settings" />
                    </MenuItem>
                    <MenuItem onClick={() => onEdit(`/media/campaigns/${campaign.id}/v${campaign.version}/manage/media-plan`, campaign)}>
                        <ListItemIcon><ViewDayIcon /></ListItemIcon>
                        <ListItemText inset primary="Media Plan" />
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={this.deleteCampaign}>
                        <ListItemIcon><DeleteForeverIcon /></ListItemIcon>
                        <ListItemText inset primary="Delete" />
                    </MenuItem>
                </DataTable>
            }
            <CreateModal title="Create Campaign" open={showCreateModal} closeHandler={this.toggleCreateModal} saveHandler={this.createCampaign}>
                <Grid container item spacing={24}>
                    <Grid item xs>
                        <TextField autoFocus value={campaign.name} onChange={e => this.handleInputChange('name', e.target.value)} id="name" name="name" label="Campaign Name" type="text" fullWidth />
                    </Grid>
                </Grid>
                {
                    !advertisersLoading &&
                    <Grid container item spacing={24}>
                        <Grid item xs>
                        {
                            advertisers &&
                            <Select options={[].concat(advertisers).map(x => { return { 'label': x.name, 'value': x.id } })} value={campaign.advertiserId} name="advertiserId" label="Advertiser"
                                onChange={value => this.handleInputChange('advertiserId', value)} placeholder="Please select an Advertiser" />
                        }
                        </Grid>
                    </Grid>
                }
                {
                    !advertisersLoading &&
                    <Grid container item spacing={24}>
                        <Grid item xs>
                        {
                            <Select options={selectedAdvertiser.brands.map(x => { return { 'label': x, 'value': x } })}
                                disabled={!campaign.advertiserId} value={campaign.brand} name="brand" label="Brand" 
                                onChange={value => this.handleInputChange('brand', value)}
                                placeholder={!campaign.advertiserId ? "Select an Advertiser First" : "Please select a Brand"} />
                        }
                        </Grid>
                    </Grid>
                }
                <Grid container item spacing={24} >
                    <Grid item lg={6}>
                        <DatePicker autoOk label="Start Date" id="startDate" name="startDate" value={campaign.startDate} format="DD/MM/YYYY"
                            onChange={value => this.handleInputChange('startDate', value)} animateYearScrolling={false} />
                    </Grid>
                    <Grid item lg={6}>
                        <DatePicker autoOk label="End Date" id="endDate" name="endDate" value={campaign.endDate} format="DD/MM/YYYY"
                            onChange={value => this.handleInputChange('endDate', value)} animateYearScrolling={false} />
                    </Grid>
                </Grid>
            </CreateModal>
        </AppContent>)
    }
}

export default CampaignList;


// WEBPACK FOOTER //
// ./src/Components/Presentation/Campaigns/CampaignList.js